// extracted by mini-css-extract-plugin
module.exports = {"menuItem":"G_tw g_jc g_ff g_fj g_ft g_dB g_t","menuItemSub":"G_tx g_dJ g_ff g_ft","menuMainLink":"G_ty g_jd g_g8","menuLink":"G_tz g_jd g_g8","Link":"G_sc y_sc y_rB y_rW"};